import { passwordChecks } from '../lib/auth';
import './PasswordStrength.css';

const SHORT: Record<string, string> = {
  '8 or more characters': '8+ characters',
  'upper case letter': 'A–Z',
  'lower case letter': 'a–z',
  number: '0–9',
  symbol: 'Symbol',
};

/**
 * A quiet strength bar and soft pills that turn teal as each rule is met, so
 * people see progress as they type. Always the same height, so the form never
 * jumps.
 */
export function PasswordStrength({ password, id }: { password: string; id?: string }) {
  const checks = passwordChecks(password);
  const met = checks.filter((c) => c.ok).length;
  return (
    <div className="pw" id={id}>
      <div className="pw-track" aria-hidden="true">
        {checks.map((c, i) => (
          <span key={c.label} className={password && i < met ? 'pw-on' : undefined} />
        ))}
      </div>
      <ul className="pw-rules" aria-label="Password rules">
        {checks.map((c) => (
          <li key={c.label} className={c.ok ? 'pw-rule pw-rule-ok' : 'pw-rule'}>
            <span aria-hidden="true">{SHORT[c.label] ?? c.label}</span>
            <span className="sr-label">
              {c.label}: {c.ok ? 'done' : 'not yet'}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
